import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  Collapse,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import "../../assets/scss/components/LandingPage/index.scss";

import { Bar, Pie } from "react-chartjs-2";
import {
  fetchBarGraphStatistics,
  fetchCustomerStatistics,
  fetchEventsStatistics,
  fetchPieChartStatistics,
  fetchRidesStatistics,
} from "../../redux/Statistics/actions";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/scss/components/CustomDatepicker/index.scss";
import { calendar } from "react-icons-kit/fa/calendar";
import get from "lodash/get";
import moment from "moment";
import history from "../../history";
import CustomButton from "../CustomButton";
import InputText from "../InputText";
import CustomDatepicker from "../CustomDatepicker";
import { toast } from "react-toastify";
import CartTitle from "../CartTitle";
import TourDetails from "../TourDetails";
import TestimonialDetails from "../TestimonialDetails";
import {
  fetchToursDetail,
  fetchToursList,
} from "../../redux/moderation/tours/actions";
import {
  fetchTestimonialDetails,
  fetchTestimonialList,
} from "../../redux/Testimonials/action";
import {
  fetchExperienceDetail,
  fetchExperiencesList,
} from "../../redux/moderation/experience/actions";
import ExperienceDetail from "../ExperienceDetail";
import { fetchingCountriesJson } from "../../redux/Global/actions";
import Loader from "../Loader";

const _ = { get };

const ActivityToursLandingPage = () => {
  const dispatch = useDispatch();
  const {
    pieChartStatistics,
    customerStatistics,
    eventsStatistics,
    ridesStatistics,
  } = useSelector((state) => state.statistics);
  const { elements } = useSelector((state) => state.Elements);
  const { countries, tourCountriesJson } = useSelector((state) => state.Global);
  const { accessibleCountries } = useSelector(
    (state) => state.Auth.userProfile
  );
  const { toursList, toursListCount, toursDetails,tourLoading } = useSelector(
    (state) => state.Tours
  );
  const { experienceList, experienceDetails,experienceLoading } = useSelector(
    (state) => state.Experience
  );
  const {
    testimonialsList,
    testimonialsListCount,
    testimonialLoading,
    testimonialsDetailsData,
  } = useSelector((state) => state.Testimonials);

  const [toggleActive, setToggleActive] = useState(true);
  const [toggleCollapse, setToggleCollapse] = useState(false);
  const [country, setCountry] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [parsedCountry, setParsedCountry] = useState("");
  const [category, setCategory] = useState("");
  const [testimonialDetail, setTestimonialDetails] = useState(false);
  const [tourDetails, setTourDetails] = useState(false);
  const [toursDetailsId, setTourDetailsId] = useState("");
  const [experienceDetail, setExperienceDetails] = useState(false);
  const [experienceDetailsId, setExperienceDetailsId] = useState("");
  const [testimonialDetailId, setTestimonialDetailsId] = useState(false);

  const handleGetDetails = () => {
    dispatch(fetchToursDetail(toursDetailsId));
  };
  const handleDetails = () => {
    dispatch(fetchTestimonialDetails(testimonialDetailId));
  };
  const handleExperienceDetails = () => {
    dispatch(fetchExperienceDetail(experienceDetailsId));
  };

  const { usertype, userProfile } = useSelector((state) => state.Auth);

  const handleToggle = (e) => {
    setToggleActive(!toggleActive);
    if (toggleCollapse === true) {
      setToggleCollapse(!toggleCollapse);
    }
  };

  const handleSearch = () => {
    // if (category == "TOUR") {
    dispatch(
      fetchToursList(
        {
          page: 0,
          limit: 100,
          category: category,
          status: "",
          country: country,
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
    // }
    // else if (category == "EXPERIENCE") {
    dispatch(
      fetchExperiencesList(
        {
          page: 0,
          limit: 100,
          category: category,
          status: "",
          country: country,
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
    // }
    dispatch(
      fetchTestimonialList(
        {
          page: 0,
          limit: 100,
          status: "",
          country: country,
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
          state: "",
          city: "",
          email: "",
          phone: "",
        },
        "overview"
      )
    );
  };

  const handleClearFilter = () => {
    setStartDate("");
    setEndDate("");
    setCountry("");
    setCategory("");
    dispatch(
      fetchToursList(
        {
          page: 0,
          limit: 100,
          category: "TOUR",
          status: "",
          country: "",
          startDate: null,
          endDate: null,
        },
        "overview"
      )
    );
    // }
    // else if (category == "EXPERIENCE") {
    dispatch(
      fetchExperiencesList(
        {
          page: 0,
          limit: 100,
          category: "EXPERIENCE",
          status: "",
          country: "",
          startDate: null,
          endDate: null,
        },
        "overview"
      )
    );
    // }
    dispatch(
      fetchTestimonialList(
        {
          page: 0,
          limit: 100,
          status: "",
          country: "",
          startDate: null,
          endDate: null,
          state: "",
          city: "",
          email: "",
          phone: "",
        },
        "overview"
      )
    );
    // dispatch(fetchToursList(obj));
    // dispatch(fetchExperiencesList(obj));
    // dispatch(fetchTestimonialList(obj));
  };

  const handleCountryChange = (e) => {
    if (e.target.value !== "") {
      setCountry(e.target.value);
      let countryCode = tourCountriesJson.filter((item) => {
        if (item.country === e.target.value) {
          return item.locality.country;
        }
      })[0].locality.country;
      setCountryCode(countryCode);
    } else {
      setCountry("");
    }
  };

  const handleCallBack = () => {
    dispatch(
      fetchToursList(
        {
          page: 0,
          limit: 100,
          category: "TOUR",
          country: country,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
    dispatch(
      fetchExperiencesList(
        {
          page: 0,
          limit: 100,
          category: "EXPERIENCE",
          country: country,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
    dispatch(
      fetchTestimonialList(
        {
          page: 0,
          limit: 100,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
          country: country,
          state: "",
          city: "",
          email: "",
          phone: "",
        },
        "overview"
      )
    );
  };
  // useEffect(() => {
  //   if (accessibleCountries && countries && countries.length !== 0) {
  //     if (accessibleCountries.length === 1 && accessibleCountries[0] === "*") {
  //       setCountryList(countries);
  //     } else if (
  //       accessibleCountries.length === 1 &&
  //       accessibleCountries[0] !== "*"
  //     ) {
  //       let newCountry = countries.filter((data) =>
  //         accessibleCountries.includes(data.locality.country)
  //       );
  //       setCountryList(newCountry);
  //       let code = newCountry[0].locality.country;
  //       let countryName = newCountry[0].country;

  //       setCountry(countryName);
  //       setCountryCode(code);
  //     } else {
  //       setCountryList(
  //         countries.filter((data) =>
  //           accessibleCountries.includes(data.locality.country)
  //         )
  //       );
  //     }
  //   }
  // }, [accessibleCountries, countries]);

  useEffect(() => {
    if (category === "") {
      dispatch(
        fetchToursList(
          {
            page: 0,
            limit: 100,
            category: "TOUR",
            country: country,
            status: "",
            startDate:
              startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
            endDate:
              endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
          },
          "overview"
        )
      );
      dispatch(
        fetchExperiencesList(
          {
            page: 0,
            limit: 100,
            category: "EXPERIENCE",
            country: country,
            status: "",
            startDate:
              startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
            endDate:
              endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
          },
          "overview"
        )
      );
      dispatch(
        fetchTestimonialList(
          {
            page: 0,
            limit: 100,
            status: "",
            startDate:
              startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
            endDate:
              endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
            country: country,
            state: "",
            city: "",
            email: "",
            phone: "",
          },
          "overview"
        )
      );
    }
    if (category == "TOUR") {
      dispatch(
        fetchToursList(
          {
            page: 0,
            limit: 100,
            category: category,
            country: country,
            status: "",
            startDate:
              startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
            endDate:
              endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
          },
          "overview"
        )
      );
      dispatch(
        fetchTestimonialList(
          {
            page: 0,
            limit: 100,
            status: "",
            startDate:
              startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
            endDate:
              endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
            country: country,
            state: "",
            city: "",
            email: "",
            phone: "",
          },
          "overview"
        )
      );
    } else if (category == "EXPERIENCE") {
      dispatch(
        fetchExperiencesList(
          {
            page: 0,
            limit: 100,
            category: category,
            country: country,
            status: "",
            startDate:
              startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
            endDate:
              endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
          },
          "overview"
        )
      );
      dispatch(
        fetchTestimonialList(
          {
            page: 0,
            limit: 100,
            status: "",
            startDate:
              startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
            endDate:
              endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
            country: country,
            state: "",
            city: "",
            email: "",
            phone: "",
          },
          "overview"
        )
      );
    }
  }, []);

  useEffect(() => {
    dispatch(fetchingCountriesJson());
  }, []);

  console.log("testimonialsList", testimonialsList);

  return (
    <>
      <div className="mt-4 px-3 pb-3">
      {tourLoading && experienceLoading && testimonialLoading && <Loader />}
        <Row>
          <Col sm={12}>
            <CartTitle
              title={`${_.get(
                elements,
                "euToursElement.partnerLandingPage.welcomeText",
                "Welcome"
              )} ${userProfile.fName} ${userProfile.lName}`}
              Name={_.get(
                elements,
                "euToursElement.partnerLandingPage.filterButtonElement",
                "Filter"
              )}
              iconClass={"hideexcel"}
              handleToggle={() => handleToggle()}
            />
          </Col>
          <Col sm={12}>
            <Collapse isOpen={toggleActive}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col xl={3} lg={3} md={6} sm={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerLandingPage.selectCategoryElement",
                          "Select Category"
                        )}
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="City"
                          className="w-100 customeSelectBtn"
                          value={category}
                          onChange={(e) => setCategory(e.target.value)}
                        >
                          <option value="">
                            {_.get(
                              elements,
                              "euToursElement.partnerLandingPage.selectCategoryPlaceholderElement",
                              "Select Category"
                            )}
                          </option>
                          <option value="TOUR">
                            {_.get(
                              elements,
                              "euToursElement.partnerLandingPage.tourCategoryOptionElement",
                              "Tours"
                            )}
                          </option>
                          <option value="EXPERIENCE">
                            {_.get(
                              elements,
                              "euToursElement.partnerLandingPage.experienceCategoryOptionElement",
                              "Experience"
                            )}
                          </option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col xl={3} lg={3} md={6} sm={6}>
                      <Label className="inputLabel">
                        {" "}
                        {_.get(
                          elements,
                          "euToursElement.partnerLandingPage.selectCountryElement",
                          "Select Country"
                        )}
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="country"
                          className="w-100 customeSelectBtn"
                          value={country}
                          onChange={(e) => handleCountryChange(e)}
                        >
                          <option value="">
                            {_.get(
                              elements,
                              "euToursElement.partnerLandingPage.countryLabel",
                              "All Countries"
                            )}
                          </option>
                          {tourCountriesJson &&
                            tourCountriesJson.length > 0 &&
                            tourCountriesJson
                              .sort((a, b) =>
                                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                              )
                              .map((item, index) => (
                                <option key={index} value={item.country}>
                                  {item.country}
                                </option>
                              ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg={3} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerLandingPage.startDateLabelElement",
                          "Start Date"
                        )}{" "}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={startDate}
                          customPlaceHolder={_.get(
                            elements,
                            "euToursElement.partnerLandingPage.startDatePlaceHolderElement",
                            "Select Start Date"
                          )}
                          handleDateChange={(startDate) =>
                            setStartDate(startDate)
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg={3} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerLandingPage.endDateLabelElement",
                          "End Date"
                        )}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={endDate}
                          customPlaceHolder={_.get(
                            elements,
                            "euToursElement.partnerLandingPage.endDatePlaceHolderElement",
                            "Select End Date"
                          )}
                          handleDateChange={(endDate) => setEndDate(endDate)}
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMinDate={startDate}
                          customDisable={startDate === ""}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-flex mt-3">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "euToursElement.partnerLandingPage.searchButtonElement",
                            "Search"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => handleSearch()}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "euToursElement.partnerLandingPage.clearFilterButtonElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => handleClearFilter()}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Collapse>
          </Col>
        </Row>
        <Row>
          <Col xl={6} md={6} lg={6} xs={12} className="pb-4">
            <div className="white-box shadow whitebox_Height position-relative table_box">
              <div className="d-flex justify-content-between">
                <h5 className="pie_heading font-weight-bold p-3">
                  {_.get(
                    elements,
                    "euToursElement.partnerLandingPage.latestToursElement",
                    "Latest Tours"
                  )}
                </h5>
              </div>
              <div className="scrollable_details admin_scroll_height">
                {(category === "" || category === "TOUR") &&
                toursList &&
                toursList.length > 0 ? (
                  <table className="table_partner">
                    <thead>
                      <tr className="table_row">
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.nameLabel",
                            "Name"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.statusLabel",
                            "Status"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.actionLabel",
                            "Action"
                          )}
                        </th>
                      </tr>
                    </thead>
                    {toursList &&
                      toursList.map((item) => (
                        <tbody>
                          <tr className="table_row">
                            <td className="table_value table_line">
                              {item && item.name}
                            </td>
                            <td className="table_value table_line">
                              {item && item.moderationStatus}
                            </td>
                            <td
                              className="view_details table_line"
                              onClick={() => {
                                setTourDetails(!tourDetails);
                                setTourDetailsId(item._id);
                              }}
                            >
                              {_.get(
                                elements,
                                "euToursElement.partnerLandingPage.viewDetailButtonElement",
                                "View detail"
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </table>
                ) : (
                  <div className="nodata_Text">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.partnerLandingPage.noDataToShowElement",
                        "No data to show"
                      )}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col xl={6} md={6} lg={6} xs={12} className="pb-4">
            <div className="white-box shadow whitebox_Height position-relative table_box">
              <div className="d-flex justify-content-between">
                <h5 className="pie_heading font-weight-bold p-3">
                  {_.get(
                    elements,
                    "euToursElement.partnerLandingPage.latestExperienceElement",
                    "Latest Experiences"
                  )}
                </h5>
              </div>
              <div className="scrollable_details admin_scroll_height">
                {(category === "" || category === "EXPERIENCE") &&
                experienceList &&
                experienceList.length > 0 ? (
                  <table className="table_partner">
                    <thead>
                      <tr className="table_row">
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.nameLabel",
                            "Name"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.statusLabel",
                            "Status"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.actionLabel",
                            "Action"
                          )}
                        </th>
                      </tr>
                    </thead>
                    {experienceList &&
                      experienceList.map((item) => (
                        <tbody>
                          <tr className="table_row">
                            <td className="table_value table_line">
                              {item && item.name}
                            </td>
                            <td className="table_value table_line">
                              {item && item.moderationStatus}
                            </td>
                            <td
                              className="view_details table_line"
                              onClick={() => {
                                setExperienceDetails(!experienceDetail);
                                setExperienceDetailsId(item._id);
                              }}
                            >
                              {_.get(
                                elements,
                                "euToursElement.partnerLandingPage.viewDetailButtonElement",
                                "View detail"
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </table>
                ) : (
                  <div className="nodata_Text">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.partnerLandingPage.noDataToShowElement",
                        "No data to show"
                      )}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col xl={6} md={6} lg={6} xs={12} className="pb-4">
            <div className="white-box shadow whitebox_Height position-relative  ">
              <h5 className="pie_heading font-weight-bold mb-4">
                {_.get(
                  elements,
                  "euToursElement.partnerLandingPage.recentTestimonialsElement",
                  "Testimonials"
                )}
              </h5>
              <div className="scrollable_details admin_scroll_height">
                {testimonialsList && testimonialsList.length > 0 ? (
                  <table className="table_partner">
                    <thead>
                      <tr className="table_row">
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.nameLabel",
                            "Name"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.nameLabel",
                            "Description"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.statusLabel",
                            "Status"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.actionLabel",
                            "Action"
                          )}
                        </th>
                      </tr>
                    </thead>
                    {testimonialsList &&
                      testimonialsList.map((item) => (
                        <tbody>
                          <tr className="table_row">
                            <td className="table_value table_line">
                              {item && item.author}
                            </td>
                            <td className="table_value table_line">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.description.replace(
                                    /(.{10})..+/,
                                    "$1…"
                                  ),
                                }}
                              />
                            </td>
                            <td className="table_value table_line">
                              {item && item.moderationStatus}
                            </td>
                            <td
                              className="view_details table_line"
                              onClick={() => {
                                setTestimonialDetails(!testimonialDetail);
                                setTestimonialDetailsId(item._id);
                              }}
                            >
                              {_.get(
                                elements,
                                "euToursElement.partnerLandingPage.viewDetailButtonElement",
                                "View detail"
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </table>
                ) : (
                  <div className="nodata_Text">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.partnerLandingPage.noDataToShowElement",
                        "No data to show"
                      )}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
        <Modal
          isOpen={tourDetails}
          toggle={() => setTourDetails(!tourDetails)}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <TourDetails
              selectedId={toursDetailsId}
              tourDetails={toursDetails}
              handleBackCall={handleCallBack}
              handleGetDetails={() => handleGetDetails()}
              handleToggleModel={() => setTourDetails(!tourDetails)}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={experienceDetail}
          toggle={() => setExperienceDetails(!experienceDetail)}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <ExperienceDetail
              selectedId={experienceDetailsId}
              tourDetails={experienceDetails}
              handleBackCall={handleCallBack}
              handleGetDetails={() => handleExperienceDetails()}
              handleToggleModel={() => setExperienceDetails(!experienceDetail)}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={testimonialDetail}
          toggle={() => setTestimonialDetails(!testimonialDetail)}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <TestimonialDetails
              selectedId={testimonialDetailId}
              testimonialsDetailsData={testimonialsDetailsData}
              handleBackCall={handleCallBack}
              handleFetchTestimonialDetails={() => handleDetails()}
              handleToggleModel={() =>
                setTestimonialDetails(!testimonialDetail)
              }
            />
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default ActivityToursLandingPage;
